// src/components/NotificationEditModal.js
import React, { useState, useEffect } from "react";

const NotificationEditModal = ({ show, onClose, postId, initialContent, userId, onSaveSuccess }) => {
  const [editContent, setEditContent] = useState(initialContent || "");

  useEffect(() => {
    setEditContent(initialContent || "");
  }, [initialContent]);

  const handleSave = async () => {
    if (!editContent.trim()) return alert("Content cannot be empty.");

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/notifications/posts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: postId,
          user_id: userId,
          message: editContent.trim()
        })
      });

      const data = await res.json();
      if (!data.success) throw new Error("Edit failed");

      onSaveSuccess();
    } catch (err) {
      console.error("❌ Edit error:", err);
      alert("Could not update post");
    }
  };

  if (!show) return null;

  return (
    <div id="notification-modal" className="modal-overlay">
      <div className="modal-content">
        <h3>Edit System Message</h3>
        <textarea
          value={editContent}
          onChange={(e) => setEditContent(e.target.value)}
          rows={5}
          className="modal-textarea"
        />
        <div className="modal-actions">
          <button onClick={handleSave} className="save-btn">💾 Save</button>
          <button onClick={onClose} className="cancel-btn">✖ Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default NotificationEditModal;
